import { render, staticRenderFns } from "./ShareholdersTree.vue?vue&type=template&id=4cd2fae7"
import script from "./ShareholdersTree.vue?vue&type=script&lang=js"
export * from "./ShareholdersTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports